export default __webpack_public_path__ + "static/media/hebrewlang_logo.22a6cad0.jpg";